namespace RedBullMOBILE360.CustomerCare {
    export interface ManualResumeResponse extends Serenity.ServiceResponse {
        Message?: string;
        FailedRecords?: string[];
    }
}
